// eslint-disable-next-line import/prefer-default-export
import Api from '@/modules/projectA/api/paymentAccount/index';
import { epecToken } from '../../utils/globalData';
import { emailReg, idCardReg, mobileReg } from '../../utils/verification';
// 0,居民身份证,1武装警察身份证,2护照,3军人身份证,4港澳居民往来内地通行证,5台湾居民往来大陆通行证,6户口簿,7临时居民身份证
export const certificateTypeList = [
  { itemCode: 0, itemDisp: '居民身份证' },
  { itemCode: 1, itemDisp: '武装警察身份证' },
  { itemCode: 2, itemDisp: '护照' },
  { itemCode: 3, itemDisp: '军人身份证' },
  { itemCode: 4, itemDisp: '港澳居民往来内地通行证' },
  { itemCode: 5, itemDisp: '台湾居民往来大陆通行证' },
  { itemCode: 6, itemDisp: '户口簿' },
  { itemCode: 7, itemDisp: '临时居民身份证' },
];
export const { uploadPayCenterFile } = Api;
export const headers = epecToken;
export const privateUpload = {
  keyName: 'filePath',
  url: Api.getSupplierLicence,
  method: 'get',
};
export const downloadTemplateUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://static.epec.com'
    : 'https://static.epec.com';
export const logoutCompanyAccount = 'logoutCompanyAccount';
export const paymentAccountOpeningMixins = {
  data() {
    return {
      defaultForm: {
        companyName: '', // 公司名称
        regCity: '', // 公司注册地
        province: '',
        city: '',
        district: '',
        attachment: {}, // 营业执照号
        creator: '', // 申请人
        creatorRealName: '', // 易派客用户名
      },
      rules: {
        legalPerson: [
          { required: true, message: '请输入法人名称', trigger: 'blur' },
        ],
        legalPersonMobile: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              if (!mobileReg.test(value)) {
                callback(new Error('请输入正确的手机号'));
              }
              callback();
            },
            trigger: 'blur',
          },
        ],
        bankAccount: [
          { required: true, message: '请输入开户银行账号', trigger: 'blur' },
        ],
        bankAccountName: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        bankName: [
          { required: true, message: '请输入开户银行名称', trigger: 'blur' },
        ],
        bankSerials: [
          { required: true, message: '请选择开户银行行号', trigger: 'change' },
        ],
        certificateNo: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              if (
                ['operatorCertificateNo', 'auditorCertificateNo'].includes(
                  rule.field
                )
              ) {
                // 经办员
                const operator =
                  this.ruleForm.settleAccountUserTempList[0]
                    .settleAccountUserAttachTempList[
                  this.getIndexByFileType(
                    'UC',
                    this.ruleForm.settleAccountUserTempList[0]
                      .settleAccountUserAttachTempList
                  )
                  ];
                // 审核员
                const auditor =
                  this.ruleForm.settleAccountUserTempList[1]
                    .settleAccountUserAttachTempList[
                  this.getIndexByFileType(
                    'UC',
                    this.ruleForm.settleAccountUserTempList[1]
                      .settleAccountUserAttachTempList
                  )
                  ];
                const obj =
                  rule.field === 'operatorCertificateNo' ? operator : auditor;
                const fieldObj =
                  this.ruleForm.settleAccountUserTempList[
                  rule.field === 'operatorCertificateNo' ? 0 : 1
                  ];
                if (fieldObj?.certificateType !== 0 && !obj.certificateNo) {
                  callback('请输入证件号码');
                } else if (
                  fieldObj?.certificateType === 0 &&
                  this.idCardValidity(obj.certificateNo)
                ) {
                  // 身份证类型时，校验身份证号格式
                  if (
                    this.activeTab === '1' &&
                    rule.field === 'auditorCertificateNo'
                  ) {
                    callback();
                  } else {
                    callback(this.idCardValidity(obj.certificateNo));
                  }
                } else if (
                  this.activeTab === '2' &&
                  operator.certificateNo === auditor.certificateNo
                ) {
                  callback('审核员、经办员证件号码不能相同');
                } else {
                  const res =
                    await Api.checkEpaySettleAccountUserIDNumberUnique({
                      certificateType:
                        this.ruleForm.settleAccountUserTempList[
                          rule.field === 'operatorCertificateNo' ? 0 : 1
                        ].certificateType,
                      iDNumber: obj.certificateNo,
                    });
                  if (res.code === '200' && !res.data.status) {
                    callback(res.data.msg);
                  }
                }
              } else {
                const fieldArr = rule.field.split('.')[0].split('[');
                const fieldObj =
                  this.ruleForm[fieldArr[0]][fieldArr[1].slice(0, 1)];
                // 证件类型为身份证类型时，校验身份证号格式
                if (fieldObj?.certificateType === 0) {
                  if (this.idCardValidity(value)) {
                    callback(this.idCardValidity(value));
                  }
                  callback();
                } else {
                  if (!value) {
                    callback('请输入证件号码');
                  }
                  callback();
                }
              }
            },
            trigger: 'blur',
          },
        ],
        certificateTimeRange: [
          { required: true, message: '请选择证件有效期', trigger: 'change' },
        ],
        attachPath: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              switch (rule.field) {
                // 申请人身份证件
                case 'applyCertificate':
                  if (!this.fileList.AC.length) {
                    callback('请上传');
                  }
                  break;
                // 申请人授权书
                case 'applyEmpower':
                  if (!this.fileList.AA.length) {
                    callback('请上传');
                  }
                  break;
                // 法人身份证件
                case 'legalPersonCertificate':
                  if (!this.fileList.LRC.length) {
                    callback('请上传');
                  }
                  break;
                // 经办员身份证件
                case 'operatorCertificate':
                  if (!this.userFileList[0].UC.length) {
                    callback('请上传');
                  }
                  break;
                // 审核员身份证件
                case 'auditorCertificate':
                  if (
                    !this.userFileList[1].UC.length &&
                    this.activeTab === '2'
                  ) {
                    callback('请上传');
                  }
                  break;
                // 个人信息处理告知同意书
                case 'notificationLetter':
                  if (!this.userFileList[1].PPN.length) {
                    callback('请上传');
                  }
                  break;
                default:
                  if (!value) {
                    callback('请上传');
                  }
                  break;
              }
              callback();
            },
            trigger: 'change',
          },
        ],
        realName: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              if (
                !value &&
                (this.activeTab !== '1' ||
                  rule.field !== 'settleAccountUserTempList[1].realName')
              ) {
                callback(new Error('请输入姓名'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        paycenterLoginAccount: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              if (!value) {
                if (
                  this.activeTab === '1' &&
                  rule.field ===
                  'settleAccountUserTempList[1].paycenterLoginAccount'
                ) {
                  callback();
                } else {
                  callback(new Error('请输入支付平台登录名称'));
                }
              } else if (
                this.activeTab === '2' &&
                this.ruleForm.settleAccountUserTempList[0]
                  .paycenterLoginAccount ===
                this.ruleForm.settleAccountUserTempList[1]
                  .paycenterLoginAccount
              ) {
                callback('审核员、经办员支付平台登录名称不能相同');
              } else {
                const res =
                  await Api.checkEpaySettleAccountUserLoginAccountUnique({
                    paycenterLoginAccount: value,
                  });
                if (res.code === '200' && !res.data.status) {
                  callback(res.data.msg);
                }
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              if (!mobileReg.test(value)) {
                if (
                  this.activeTab === '1' &&
                  rule.field === 'settleAccountUserTempList[1].mobile'
                ) {
                  callback();
                } else {
                  callback(new Error('请输入正确的手机号'));
                }
              } else if (
                [
                  'settleAccountUserTempList[0].mobile',
                  'settleAccountUserTempList[1].mobile',
                ].includes(rule.field)
              ) {
                if (
                  this.activeTab === '2' &&
                  this.ruleForm.settleAccountUserTempList[0].mobile ===
                  this.ruleForm.settleAccountUserTempList[1].mobile
                ) {
                  callback('审核员、经办员手机号不能相同');
                } else {
                  const res = await Api.checkEpaySettleAccountUserMobileUnique({
                    mobile: value,
                  });
                  if (res.code === '200' && !res.data.status) {
                    callback(res.data.msg);
                  }
                }
              }
              callback();
            },
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              if (!emailReg.test(value)) {
                if (
                  this.activeTab === '1' &&
                  rule.field === 'settleAccountUserTempList[1].email'
                ) {
                  callback();
                } else {
                  callback(new Error('请输入正确的邮箱地址'));
                }
              } else if (
                this.activeTab === '2' &&
                this.ruleForm.settleAccountUserTempList[0].email ===
                this.ruleForm.settleAccountUserTempList[1].email
              ) {
                callback('审核员、经办员邮箱不能相同');
              } else {
                const res = await Api.checkEpaySettleAccountUserEmailUnique({
                  email: value,
                });
                if (res.code === '200' && !res.data.status) {
                  callback(res.data.msg);
                }
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        imageCode: [
          { required: true, message: '请输入图形验证码', trigger: 'blur' },
        ],
        smsCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
        ],
        receiverCompanyName: [
          { required: true, message: '请输入收件人公司', trigger: 'blur' },
        ],
        districtId: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                !this.ruleForm.settleAccountUkeyTemp.provinceId ||
                !this.ruleForm.settleAccountUkeyTemp.cityId ||
                !this.ruleForm.settleAccountUkeyTemp.districtId ||
                !this.ruleForm.settleAccountUkeyTemp.address
              ) {
                callback(new Error('请输入收件人地址'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
        checked: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请阅读'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
      },
      dialogPicUrl: '',
      mrcDateShow: false,
      uploadPayCenterFile,
      headers,
      // 私有仓库得地址
      privateUpload,
      reUploadFlag: false, // 是否重新上传
      certificateTypeList,
    };
  },
  methods: {
    // 获取附件信息下标
    getIndexByFileType(type, list) {
      const sourceData = list ?? this.ruleForm?.settleAccountAttachTempList;
      return sourceData?.findIndex((item) => item.attachType === type);
    },
    // 校验身份证号
    idCardValidity(code) {
      const city = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外 ',
      };
      let tip = '';
      let pass = true;
      if (!code) {
        tip = '请输入证件号码';
        pass = false;
      } else if (
        !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
          code
        )
      ) {
        tip = '身份证号格式错误';
        pass = false;
      } else if (!city[code.substr(0, 2)]) {
        tip = '地址编码错误';
        pass = false;
      } else {
        // 18位身份证需要验证最后一位校验位
        // if (code.length === 18) {
        //   code = code.split('');
        //   // ∑(ai×Wi)(mod 11)
        //   // 加权因子
        //   const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        //   // 校验位
        //   const parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
        //   let sum = 0;
        //   let ai = 0;
        //   let wi = 0;
        //   for (let i = 0; i < 17; i++) {
        //     ai = code[i];
        //     wi = factor[i];
        //     sum += ai * wi;
        //   }
        //   if (parity[sum % 11] != code[17]) {
        //     tip = '校验位错误';
        //     pass = false;
        //   }
        // }
      }
      if (!pass) {
        return tip;
      }
      return '';
    },
  },
};
export const commonMethodsMixins = {
  data() {
    return {};
  },
  methods: {
    // 预览上传的文件
    previewUploadFile(attachObj) {
      // console.log(attachObj, 'previewUploadFile');
      if (attachObj[0].url || attachObj[0]?.response?.data.url) {
        this.handlePreview(
          attachObj[0].url || attachObj[0]?.response?.data.url
        );
      } else {
        this.$message.info('暂无可预览文件');
      }
    },
    handlePreview(attachPath) {
      Api.getPayCenterFile({ filePath: attachPath }).then((res) => {
        if (res.code === '200') {
          this.dialogPicUrl = res.data;
          this.$refs.viewer.show();
        }
      });
    },
    // 证件有效期值改变
    radioChange(certificateType, objName = 'settleAccountAttachTempList') {
      const index = this.getIndexByFileType(certificateType);
      const certificateObj = this.ruleForm[objName][index];
      this.$nextTick(() => {
        switch (certificateType) {
          // 营业执照
          case 'MRC':
            if (certificateObj?.certificateLongValid) {
              this.mrcDateShow = false;
              certificateObj.certificateEndTime = '';
            } else {
              this.mrcDateShow = true;
            }
            break;
          // 申请人证件有效期
          case 'AC':
            if (
              certificateObj?.certificateLongValid ||
              certificateObj?.isLongTernEffective
            ) {
              this.createrDateDisabled = true;
              // 开户申请
              if (certificateObj?.certificateBeginTime) {
                certificateObj.certificateBeginTime = '';
              }
              // 开户申请
              if (certificateObj?.certificateEndTime) {
                certificateObj.certificateEndTime = '';
              }
              // 补办ukey
              if (certificateObj?.certificateValidityBegin) {
                certificateObj.certificateValidityBegin = '';
              }
              // 补办ukey
              if (certificateObj?.certificateValidityEnd) {
                certificateObj.certificateValidityEnd = '';
              }
              certificateObj.certificateTimeRange = [];
            } else {
              this.createrDateDisabled = false;
            }
            break;
          // 法人信息证件有效期
          case 'LRC':
            if (certificateObj?.certificateLongValid) {
              this.legalPersonDateDisabled = true;
              certificateObj.certificateBeginTime = '';
              certificateObj.certificateEndTime = '';
              certificateObj.certificateTimeRange = [];
            } else {
              this.legalPersonDateDisabled = false;
            }
            break;
          default:
            break;
        }
      });
    },
    deepClone(data) {
      return JSON.parse(JSON.stringify(data));
    },
  },
};
